/**
     * @desc 9购买系统盲盒，先调系统盲盒合约并将orderHash传入
用于：盲盒详情页，且是系统盲盒isSystem=1
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/box/buySystemBox', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/box/buySystemBox', params);
}
